import type { ComponentType } from 'react';
import React, { useContext } from 'react';

import { VehicleContext } from 'Context/VehicleContext';

import VehiclePermitsChecker from './VehiclePermitsChecker';

/**
 * Adds `permits` prop to component
 *
 * @param {Component} Component
 * @returns {Component} VehiclePermitsCheckerHOC
 */
export const WithVehiclePermitsChecker =
	() =>
	<T,>(Component: ComponentType<T>): ((props: T) => JSX.Element) => {
		const VehiclePermitsCheckerHOC = (props: T) => {
			const vehicle = useContext(VehicleContext);
			const permits = new VehiclePermitsChecker(vehicle);

			return <Component {...props} permits={permits} />;
		};

		return VehiclePermitsCheckerHOC;
	};
